// Containing Element needs 'hyphen-wrap' custom class for wrapping to take effect
export const toWrappableString = (str: string, threshold: number) => {
  let processed: string[] = [];
  str.split(" ").forEach((word) => {
    // Word is short, so let HTML wrapping algorithm handle it
    if (word.length < threshold) return processed.push(word);

    let breakableWord = "";
    for (let ch of word) {
      // Add on character code for '&shy;' to suggest breakpoints
      // https://developer.mozilla.org/en-US/docs/Web/CSS/hyphens
      breakableWord += ch + "\u00AD";
    }
    return processed.push(breakableWord.slice(0, -1));
  });
  return processed.join(" ");
};
